import { render, staticRenderFns } from "./CardVertical.vue?vue&type=template&id=021c3343&scoped=true"
import script from "./CardVertical.vue?vue&type=script&lang=js"
export * from "./CardVertical.vue?vue&type=script&lang=js"
import style0 from "./CardVertical.vue?vue&type=style&index=0&id=021c3343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c3343",
  null
  
)

export default component.exports